import { Button } from '@mui/material';

interface TradeActionButtonProps {
  onClick: () => void;
  disabled: boolean;
  buttonText: string;
}

export function TradeActionButton({ onClick, disabled, buttonText }: TradeActionButtonProps) {
  return (
    <Button
      fullWidth
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      sx={{
        fontFamily: 'var(--font-archivo), Archivo, sans-serif',
        bgcolor: 'primary.main',
        color: '#0a1220',
        textTransform: 'none',
        fontWeight: 700,
        fontSize: '0.96875rem',
        py: 1.75,
        borderRadius: '11px',
        mb: 0,
        boxShadow: 'none',
        '&:hover': {
          bgcolor: 'primary.dark',
          boxShadow: 'none',
        },
        '&.Mui-disabled': {
          bgcolor: 'action.disabledBackground',
          color: 'action.disabled',
        },
      }}
    >
      {buttonText}
    </Button>
  );
}
